import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import TxtBtn from './TxtBtn.js';

export default class BtnB3 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, data, quest) {
        super(scene, x, y, []);
        scene.add.existing(this);
        this.scene = scene;

        this.w = 330;
        this.h = 96;
        this.data = data
        this.title = data.titre.toUpperCase();
        this.index = data.index
        this.isSelected = false;
        this.quest = quest;
        this.questBtn = quest.validateBtn
        this.allOtherBtns = quest.allBtns.filter(btn => btn !== this);
        this.allBtnsCtnt = quest.allBtns
        this.clickSound = this.scene.sound.add('click', { volume: 0.4 });


        this.allBtns = []

        this.rect = this.scene.add.rexRoundRectangle(0, 0, this.w, this.h, 15, Colors.Elmt.lightBlue).setOrigin(0);
        this.add(this.rect);
        this.strocks = this.scene.add.rexRoundRectangle(-10, -10, this.w, this.h, 15, Colors.Elmt.lightBlue, 0).setOrigin(0);
        this.strocks.setStrokeStyle(3, Colors.Elmt.Black)
        this.add(this.strocks);

        this.txt = this.scene.add.rexTagText(this.w / 2, this.h / 2, this.title, {
            fontSize: "30px",
            fontFamily: "DKButterfly",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: this.w - 40 },
            tags: tags
        }).setOrigin(0.5, 0.5);
        this.add(this.txt);


        this.good = this.scene.add.image(30, -20, "goodB3").setOrigin(0.5).setAlpha(0);
        this.add(this.good);

        this.wrong = this.scene.add.image(30, -15, "wrongB3").setOrigin(0.5).setAlpha(0);
        this.add(this.wrong);

        this.setSize(this.w, this.h);
        this.setInteractive({ useHandCursor: true });
        this.input.hitArea.setTo(this.w / 2 - 14, this.h / 2 - 14, this.w + 14, this.h + 14);

        this.on('pointerdown', () => {
            this.clickSound.play();
            if (this.isSelected) {
                this.setUnselected()
                this.quest.validateBtn.setLocked()
            } else {
                // console.log(this.allBtnsCtnt)
                // console.log(this.allOtherBtns)
                this.quest.allBtns.filter(btn => btn !== this).forEach(btn => btn.setUnselected());
                // this.allOtherBtns.forEach(btn => btn.setUnselected());
                this.setSelected()
                this.quest.validateBtn.setUnlocked()
                this.quest.selectedAnswer = this

            }

        })

        // this.setLocked();
    }

    setClickFunction(clickFunction) {
        this.on('pointerup', () => {
            clickFunction(this);
        }, this.scene);
    }

    setSelected() {
        console.log('selected')
        this.rect.setFillStyle(Colors.Elmt.MainBlue);
        this.isSelected = true;
    }

    setUnselected() {
        console.log('unselected')
        this.rect.setFillStyle(Colors.Elmt.lightBlue);
        this.isSelected = false;
    }

    setGood() {
        this.rect.setFillStyle(Colors.Elmt.GoodB3);
        this.good.setAlpha(1);
    }

    setWrong() {
        this.rect.setFillStyle(Colors.Elmt.WrongB3);
        this.wrong.setAlpha(1);
    }

}